export enum TimeRangeDropdownOptions {
    CURRENT_MONTH = 'Current Month',
    LAST_3_MONTHS = 'Last 3 months',
    LAST_4_MONTHS = 'Last 4 months',
    LAST_5_MONTHS = 'Last 5 months',
    LAST_6_MONTHS = 'Last 6 months',
    LAST_7_MONTHS = 'Last 7 months',
    LAST_8_MONTHS = 'Last 8 months',
    LAST_9_MONTHS = 'Last 9 months',
    LAST_10_MONTHS = 'Last 10 months',
    LAST_11_MONTHS = 'Last 11 months',
    LAST_12_MONTHS = 'Last 12 months'
}

export const lastMonth = 'Last 1 month';